module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "line"
  }, [_vm._v("____________________")]), _vm._v(" "), _c('p', {
    staticClass: "inset"
  }, [_c('i', [_vm._v("Now consider the man. He does not overhunt. He does not overeat. Man is one with great nature. The oaf can learn much from the man. His sun rises in gold but sets in blood. His fire burns the world.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("—Great Scripture")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb2bb96a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/script.vue
// module id = 75
// module chunks = 0